module.exports = __webpack_public_path__ + "img/cal-pre-en.88b8fcda.png";